


export const hasOwnPropertyTS = <X extends object, Y extends PropertyKey>(obj: X, prop: Y): obj is X & Record<Y, unknown> => {
	return obj.hasOwnProperty(prop)
}


export const invalidFormValue = (value: unknown | null | undefined) => {
	if (value === null || value === undefined) return true;
	if (typeof value === 'string' && value === '') return true;
	if (typeof value === 'number' && value === 0) return true;
	if (Number.isNaN(value)) return true;
	return false;
}



export const isValidEmail = (email: string | null | undefined) =>
	email ? /^\S+@\S+\.\w+$/.test(email) : false;



export const isValidPhoneNumber = (numberString: string | null | undefined) =>
	numberString ? /\+?[\d\s]+\d$/.test(numberString) : false;